import { Box, Tab, Tabs } from "@mui/material";
import { useEffect, useState } from "react";
import { BorrowerService } from "../../borrowerService";
import { SummaryLoader } from "./summaryLoader";
import { useTranslation } from "react-i18next";
import { LoanSummary } from "./loanSummary";
import { LocalStorageKey } from "../../../../constants/localStorageKeys";
import { identifyOpenPanel } from "../../../../helpers/openPanelHelper";
import { getUser } from "../../../../services/authService";

export const BorrowerSummary = () => {
  const [activeLoans, setActiveLoans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTab, setSelectedTab] = useState(0);
  const { t } = useTranslation();

  useEffect(() => {
    const borrowerService = new BorrowerService();
    borrowerService
      .getActiveLoans()
      .then((resp) => {
        if (resp.data && resp.data.length > 0) {
          setActiveLoans(resp.data);
          // A stored id can outlive the loan it points at (repaid, withdrawn), and
          // findIndex then returns -1 — which used to reach setSelectedTab and
          // render activeLoans[-1], i.e. no loan panel at all. Fall back to the
          // first loan and repair the stored id rather than carrying -1 forward.
          const storedId = sessionStorage.getItem(LocalStorageKey.activeLoanId);
          const storedIndex = storedId
            ? resp.data.findIndex((loan) => loan.loanId === storedId)
            : -1;
          const activeIndex = storedIndex >= 0 ? storedIndex : 0;
          setSelectedTab(activeIndex);
          sessionStorage.setItem(LocalStorageKey.activeLoanId, resp.data[activeIndex].loanId);
          identifyOpenPanel(getUser(), { loan_id: resp.data[activeIndex].loanId });
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    sessionStorage.setItem(LocalStorageKey.activeLoanId, activeLoans[newValue].loanId);
  };

  return (
    <Box className="flex flex-col flex-0">
      {loading ? (
        <SummaryLoader />
      ) : activeLoans.length > 0 ? (
        <>
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
          >
            {activeLoans.map((loan, index) => (
              <Tab
                key={loan.id || index}
                label={loan.name || `Loan ${loan.applicationId}`}
              />
            ))}
          </Tabs>
          <Box className="grid grid-cols-1 gap-4 mt-4">
            {activeLoans[selectedTab] && (
            <LoanSummary
              key={activeLoans[selectedTab].loanId}
              loanId={activeLoans[selectedTab].loanId}
            />)}
          </Box>
        </>
      ) : (
        <Box>{t("borrower.summary.noActiveLoans")}</Box>
      )}
    </Box>
  );
};
